import { defaultAuth } from './default-auth';
import { defaultNavigate } from './default-navigate';

export function* defaultWorkflow() {
  yield defaultAuth();
  yield defaultNavigate();
}
